import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateChangeStatusApplication = {
  changeStatusApplication: { data: null, loading: false, error: null },
};

export const changeStatusApplication = createAsyncThunk('user/changeStatusApplication', async (applicationId, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/vacancies/applications/${applicationId}/status`,
      { status: 'processed' },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerChangeStatusApplication = {
  [changeStatusApplication.pending]: (state) => {
    // state.changeStatusApplication.data = null;
    state.changeStatusApplication.loading = true;
    state.changeStatusApplication.error = null;
  },
  [changeStatusApplication.fulfilled]: (state, action) => {
    state.changeStatusApplication.loading = false;
    state.changeStatusApplication.data = action.payload;
    state.changeStatusApplication.error = null;
  },
  [changeStatusApplication.rejected]: (state, action) => {
    state.changeStatusApplication.loading = false;
    state.changeStatusApplication.error = action.payload;
  },
};
